import React from "react";
import "./style.css";

function IntegrationOption({ title, contents, active, handleChange, id }) {
  return (
    <div className="col-12 option ">
      <div className="row" style={{ minHeight: "150px" }}>
        <div className="col-sm-4 vcenter">
          <h4>{title}</h4>
        </div>
        <div className="col-sm-5 vcenter">
          <div className="integration-option-list">
            <ul>
              {contents.map((content) => (
                <li>
                  <span>{content}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-sm-3 vcenter">
          <div className="integration-radioButton w-100 text-center text-md-right">
            <div className="row">
              <div className="col-12">
                <input
                  type="radio"
                  checked={active}
                  onChange={() => handleChange(id)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntegrationOption;
